import { Avatar } from '@material-ui/core';
import classNames from 'classnames';
import { Messages } from 'primereact/messages';
import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosClient from './constants';
import './styles/_AppInlineProfile.css';
export const AppInlineProfile = () => {
    const [expanded, setExpanded] = useState(false);
    const messages = useRef(null);
    const onClick = (event) => {
        event.preventDefault();
        setExpanded(!expanded)
    }
    const logout = e => {
        axiosClient.get('logout/' + localStorage.getItem("token"))
            .then(res => {
                localStorage.removeItem("userName");
                localStorage.removeItem("token");
                localStorage.removeItem("role");
                localStorage.removeItem("permissions");
            })
    }
    return <div>
        <Messages ref={messages} />
        <div className={classNames('profile', { 'profile-expanded': expanded })}>
            <div className="profile-container" onClick={onClick}>
                <Avatar alt="Profile" src="assets/layout/images/profile.png" />
                <div className="profile-details">
                    <p className="profile-name">{localStorage.getItem("userName")}</p>
                    <p className="profile-role">Role: {localStorage.getItem("role")}</p>
                </div>
                <i className="fa fa-fw fa-caret-down"></i>
            </div>
        </div>

        <ul className="layout-menu profile-menu">
            <li role="menuitem">
                <Link to="/profile">
                    <button className="p-link" tabIndex={expanded ? null : '-1'}>
                        <i className="fa fa-fw fa-user"></i>
                        <span>Profile</span>
                    </button>
                </Link>
            </li>
            <li role="menuitem">
                <Link to="/login" onClick={logout}>
                    <button className="p-link" tabIndex={expanded ? null : '-1'}>
                        <i className="fa fa-fw fa-sign-out"></i>
                        <span>Logout</span>
                    </button>
                </Link>
            </li>

        </ul>
    </div>
}